import { useEffect, useState } from 'react';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import Echancier from './Dashbords/Echancier';
import StatutCras from './Dashbords/StatutCras';
import StatutFactures from './Dashbords/StatutFactures';
import StatutMissions from './Dashbords/StatutMissions';

const Missions = () => {
    const axiosPrivate = useAxiosPrivate();
    //const [DataForCandidatureRecuParAO, SetDataForCandidatureRecuParAO] = useState();
    //const [dataAllAos, SetDataAllAos]=useState();

    //const [selectedStatutPaiementCaffaireCR, setSelectedStatutPaiementCaffaireCR] = useState('all'); // Default selected period
    const [selectedClient, setSelectedClient] = useState([]); // Default selected Client
    const [selectedBackOfficeValues, setSelectedBackOfficeValues] = useState([]);
    //const [statusCandiaturesByCompanyId,setAllStatusCandiaturesByCompanyId]= useState();
    const [allStatusMissions,setAllStatusMissions]= useState();
    const [allCras,setAllCras]= useState();
    //const [selectedBackOffice,setSelectedBackOffice]=useState('all');
    const [chiffreAffaire,setChiffreAffaire]=useState();
    const {device}=useWindowSize();

    useEffect(() =>{
        getDataForCandidatureRecuParAO();
        getAllBackOffice();
    }, []);

    const getAllBackOffice = async () => {
        try {
            const listBo=await adapter4BackendProxy(axiosPrivate,  'getAllListBackOffice');
            setSelectedBackOfficeValues(listBo);
        } catch (error) {
            console.log(error.response?.status);
        }
    };
    const { setBackdropOpen} = useUtilities();
    const getDataForCandidatureRecuParAO = async () => {
        try {
            // const response1 = await fetch(API_URI_CVTheque + 'getStatistics/'+ encodeURIComponent(temp), {
            //     method: 'Get',
            // });
            setBackdropOpen(true);
            //const [allCandidatures,totalAos,allStatusCandiatures, allMissions,cras,factures,chiffreAffaire,trafics] = await adapter4BackendProxy(axiosPrivate,  'getStatistics/None');
            //const allMissions=await adapter4BackendProxy(axiosPrivate, 'admin/getMissions');
            //const cras=await adapter4BackendProxy(axiosPrivate, 'admin/getCrasX');
            //const chiffreAffaire=await adapter4BackendProxy(axiosPrivate, 'admin/getCA');

            const [
                allMissions,
                cras,
                chiffreAffaire,
            ] = await Promise.all([
                adapter4BackendProxy(axiosPrivate, 'admin/getMissions'),
                adapter4BackendProxy(axiosPrivate, 'admin/getCrasX'),
                adapter4BackendProxy(axiosPrivate, 'admin/getCA'),
            ]);

            setChiffreAffaire(chiffreAffaire);
            setAllStatusMissions(allMissions);
            setAllCras(cras);
            setBackdropOpen(false);

        } catch (error) {
            console.log(error.response?.status);
        }
    };

    useEffect(()=>{
        getAllClient();
    },[]);

    const getAllClient = async () => {
        try {
            // const response2 = await fetch(API_URI_CVTheque + 'getAllListClient', {
            //     method: 'Get',
            // });

            const clientList = await adapter4BackendProxy(axiosPrivate,   'getAllListClient');
            clientList.push({_id: 'all',value:'all', label: 'Tous les clients'});
            console.log(Array.isArray(clientList));
            setSelectedClient(clientList);
        } catch (error) {
            console.log(error.response?.status);
        }
    };
    return (
        <>
            <StatutMissions
                allStatusMissions={allStatusMissions}
                selectedClient={selectedClient}
                filtreClient={true}
                width={'100%'}
                height={device=='desktop'?'365px':'auto'}
            />
            <div style={{display:'flex',flexDirection:device=='desktop'?'row':'column',gap:'24px',width:'100%',alignSelf:'stretch'}}>
                <StatutCras
                    allCras={allCras}
                    filtreClient={true}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'365px':'auto'}
                />

                <StatutFactures
                    allFactures={chiffreAffaire}
                    filtreClient={true}
                    width={device=='desktop'?'50%':'100%'}
                    height={device=='desktop'?'365px':'auto'}
                />
            </div>
            <Echancier
                filtreClient={true}
                chiffreAffaire={chiffreAffaire}
                selectedClient={selectedClient}
                selectedBackOfficeValues={selectedBackOfficeValues}
                width={'100%'}
                height={device=='desktop'?'365px':'auto'}
            />

        </>
    );
};
export default Missions;